<template lang="pug">
div
  v-row(no-gutters :style="`min-height: ${viewHeight};`")
    v-col.px-8.shrink
      div.sticky.white(style="width: 230px; top: 106px;")
        .text-md.font-semibold.neutral500--text.px-6.py-2.round-md.mb-2.clickable(@click="$router.push('/admin/clinic/settings/marketing')") Marketing settings
        .text-md.font-semibold.neutral200.px-6.py-2.round-md.mb-2 Wallet
    v-col.grow.neutral200
      v-container.pa-8(fluid style="max-width:1100px")
        v-row(no-gutters align="center")
          v-col.shrink
            v-btn.ml-n3(text icon @click="goBack" height)
              v-icon(color="basic800" :size="24") mdi-arrow-left
          v-col.ml-3
            .text-2xl.font-semibold.neutral700--text Wallet

        credit-balance
        div.text-xl.font-semibold.neutral700--text.mt-8 {{ $t('credit_history') }}
        credit-history.mt-4(ref="creditHistory" :company="company")
</template>

<script>
import { mapGetters } from 'vuex'
import CreditHistory from '@/components/clinic/marketing/CreditHistory.vue'
import CreditBalance from '@/components/clinic/marketing/CreditBalance.vue'

export default {
  name: 'Wallet',
  components: { CreditHistory, CreditBalance },
  data () {
    return {}
  },
  mounted () {
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      displaySize: 'ui/getDisplaySize'
    }),
    creditBalance() {
      return this.company.prepaid_credits
    },
    viewHeight () {
      switch (this.displaySize) {
        case 'xx-small':
          return '130vh'
        case 'x-small':
          return '114vh'
        case 'small':
          return '106vh'
        case 'medium':
          return '92vh'
        case 'large':
          return '81vh'
        case 'x-large':
          return '81vh'
        default:
          return '81vh'
      }
    }
  },
  methods: {
    goBack () {
      this.$router.push('/admin/clinic/settings')
    }
  }
}
</script>

<style lang="scss" scoped>
</style>